import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';

import { PermissionService } from '../permission/permission.service';
import { SessionService } from '../session/session.service';

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(
    private permission: PermissionService,
    private session: SessionService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ): boolean {
    if (route.data && route.data['permissionLevel']) {
      if (this.permission.hasAccess(route.data['permissionLevel'])) {
        return true;
      } else {
        this.session.redirectTo = router.url;
        return false;
      }
    }
    return false;
  }
}
